var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup146931(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.25C15.3325 19.25 19.25 15.3325 19.25 10.5C19.25 5.66751 15.3325 1.75 10.5 1.75C5.66751 1.75 1.75 5.66751 1.75 10.5C1.75 15.3325 5.66751 19.25 10.5 19.25Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99844 2.625H7.87344C6.16719 7.735 6.16719 13.265 7.87344 18.375H6.99844",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 2.625C14.8313 7.735 14.8313 13.265 13.125 18.375",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14V13.125C7.735 14.8313 13.265 14.8313 18.375 13.125V14",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 7.87344C7.735 6.16719 13.265 6.16719 18.375 7.87344",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0198,
    cy: 16.0002,
    r: 7.05882,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.9492C15 16.5015 15.4477 16.9492 16 16.9492C16.5523 16.9492 17 16.5015 17 15.9492C17 15.3969 16.5523 14.9492 16 14.9492C15.4477 14.9492 15 15.3969 15 15.9492Z",
    fill: "#272B30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.9519C18 15.3799 17.8085 14.8541 17.4859 14.433C17.3179 14.2138 17.3595 13.9 17.5787 13.732C17.7979 13.5641 18.1117 13.6056 18.2797 13.8248C18.7314 14.4143 19 15.1525 19 15.9519C19 16.7851 18.7082 17.5516 18.2217 18.1526C18.0479 18.3673 17.7331 18.4004 17.5185 18.2267C17.3038 18.0529 17.2707 17.7381 17.4444 17.5235C17.7921 17.0939 18 16.5479 18 15.9519Z",
    fill: "#272B30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15.95C14 15.3773 14.192 14.8508 14.5154 14.4295C14.6835 14.2104 14.6422 13.8965 14.4232 13.7284C14.2041 13.5603 13.8902 13.6015 13.7221 13.8206C13.2694 14.4105 13 15.1495 13 15.95C13 16.7826 13.2913 17.5485 13.7772 18.1493C13.9508 18.364 14.2656 18.3974 14.4804 18.2237C14.6951 18.0501 14.7284 17.7353 14.5548 17.5205C14.2076 17.0912 14 16.5455 14 15.95Z",
    fill: "#272B30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15.9506C20 14.8346 19.5944 13.8146 18.9219 13.0281C18.7424 12.8182 18.7671 12.5026 18.977 12.3231C19.1869 12.1437 19.5025 12.1683 19.682 12.3782C20.5034 13.339 21 14.5875 21 15.9506C21 17.3452 20.4804 18.6195 19.6249 19.5888C19.4421 19.7958 19.1262 19.8155 18.9191 19.6328C18.7121 19.4501 18.6924 19.1341 18.8751 18.9271C19.5756 18.1335 20 17.0922 20 15.9506Z",
    fill: "#272B30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.9505C12 14.8345 12.4056 13.8146 13.078 13.028C13.2574 12.8181 13.2327 12.5025 13.0228 12.3231C12.8129 12.1436 12.4973 12.1683 12.3179 12.3782C11.4965 13.339 11 14.5874 11 15.9505C11 17.3431 11.5182 18.6159 12.3717 19.5847C12.5542 19.7919 12.8702 19.8119 13.0774 19.6294C13.2846 19.4468 13.3046 19.1309 13.122 18.9237C12.4233 18.1305 12 17.0905 12 15.9505Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup146931);
export default __webpack_public_path__ + "static/media/Group 146931.1c257d6cd738c292bde5abbbcca3322c.svg";
export { ForwardRef as ReactComponent };